class ListenerManager {
  constructor() {
    this.listeners = new Map(); // Store multiple listeners by type
  }

  // Start listening with the specified type and query parameters
  startListening(type, query, onSnapshot, dispatch, onError) {
    // Stop existing listener of this type
    this.stopListening(type);

    // Store query params for comparison
    const queryParams = { type, query: JSON.stringify(query) };

    // Start new listener with error handling
    const wrappedOnSnapshot = (snapshot) => {
      try {
        onSnapshot(snapshot);
      } catch (error) {
        console.error(`🔴 Error in ${type} listener callback:`, error);
      }
    };

    const wrappedOnError = (error) => {
      if (onError) {
        onError(error);
      } else {
        console.error(`🔴 Firestore listener error (${type.toUpperCase()}):`, error);
        console.error('Error code:', error.code);
        console.error('Error message:', error.message);
      }
    };

    const listener = query.onSnapshot(wrappedOnSnapshot, wrappedOnError);

    // Store listener info
    this.listeners.set(type, {
      listener,
      queryParams,
      dispatch,
      isActive: true,
    });

    return listener;
  }

  // Stop a specific listener by type
  stopListening(type) {
    const listenerInfo = this.listeners.get(type);
    if (listenerInfo && listenerInfo.listener && typeof listenerInfo.listener === 'function') {
      listenerInfo.listener();
      this.listeners.delete(type);
    }
  }

  // Stop all listeners
  stopAllListeners() {
    this.listeners.forEach((listenerInfo, type) => {
      this.stopListening(type);
    });
  }

  // Check if a specific listener is active
  isActive(type) {
    const listenerInfo = this.listeners.get(type);
    return listenerInfo ? listenerInfo.isActive : false;
  }

  // Get current query params for a specific listener
  getCurrentQuery(type) {
    const listenerInfo = this.listeners.get(type);
    return listenerInfo ? listenerInfo.queryParams : null;
  }
}

// Export singleton instance
export const listenerManager = new ListenerManager();

// Legacy exports for backward compatibility
export const ordersListenerManager = {
  startListening: (query, onSnapshot, dispatch) =>
    listenerManager.startListening('orders', query, onSnapshot, dispatch),
  stopListening: () => listenerManager.stopListening('orders'),
  isActive: () => listenerManager.isActive('orders'),
  getCurrentQuery: () => listenerManager.getCurrentQuery('orders'),
};

export const driverWarningsListenerManager = {
  startListening: (query, onSnapshot, dispatch) =>
    listenerManager.startListening('driverWarnings', query, onSnapshot, dispatch),
  stopListening: () => listenerManager.stopListening('driverWarnings'),
  isActive: () => listenerManager.isActive('driverWarnings'),
  getCurrentQuery: () => listenerManager.getCurrentQuery('driverWarnings'),
};
